<template>
  <div>
    <span class="stats--title mb-2 fw-bold">
      {{ title }}
      <i class="fal fa-info-circle stats-info-icon" :id="titleTooltipId"></i>

      <b-popover :target="titleTooltipId" triggers="hover" placement="top">
        <span class="stats-popover-text">{{ titleTooltipContent }}</span>
      </b-popover>
    </span>

    <div class="row">
      <div class="col-8">
        <div class="highlight--stats">
          <div class="value--unit">
            <span class="stats--value">
              {{
                title === "Total QR" && typeof value !== "object"
                  ? numberWithCommas(value) + " QR"
                  : typeof value !== "object"
                    ? numberWithCommas(value)
                    : "Loading...."
              }}
            </span>
            <!-- <span class="stats--unit col-md-0 col-sm-0 col-xs-0">{{ unit }}</span> -->
          </div>
          <div class="text-left">
            <template v-if="tooltipData">
              <b-button :id="detailTooltipId" variant="link" class="p-0">
                <h5>
                  <span style="font-weight: normal"> View Detail </span>
                </h5>
              </b-button>
              <b-popover :target="detailTooltipId" triggers="hover" placement="top">
                <div class="detail-tooltip-line stats-popover-text">
                  <strong>{{ formatNumberWithCommas(tooltipData.total_unmaped) }}</strong>
                  Inactive
                </div>
                <div class="detail-tooltip-line stats-popover-text">
                  <strong>{{ formatNumberWithCommas(tooltipData.total_mapped) }}</strong>
                  Active
                </div>
              </b-popover>
            </template>
            <template v-else-if="routeToPage">
              <h5 style="color: #348fe2; cursor: pointer">
                <span style="font-weight: normal" @click="$router.push({ name: routeToPage, query: pageQuery })">View
                  Location</span>
              </h5>
            </template>
          </div>
        </div>
      </div>
      <div class="col-4 stats--icon">
        <div class="circle" :style="{
          'background-color': circle_bg_color ? circle_bg_color : '#fff',
          color: circle_text_color ? circle_text_color : '#000',
        }">
          <!-- <i class="far fa-2x" :class="icon"></i> -->
          <span v-html="icon"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    const uniqueId = Math.random().toString(36).substr(2, 9);

    return {
      mobile: this.isMobile(),
      titleTooltipId: `report-suspect-title-tooltip-${uniqueId}`,
      detailTooltipId: `report-suspect-detail-tooltip-${uniqueId}`,
    };
  },
  props: [
    "tooltipText",
    "tooltipBody",
    "title",
    "description",
    "value",
    "unit",
    "icon",
    "circle_bg_color",
    "circle_text_color",
    "tooltipData",
    "routeToPage",
    "pageQuery",
  ],
  computed: {
    titleTooltipContent() {
      return this.tooltipBody || this.tooltipText || "";
    },
  },
  mounted() { },
  methods: {
    formatNumberWithCommas(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style scoped>
.highlight--stats {
  background-color: white;
  border-radius: 8px;
  /* box-shadow: 0px 3px 10px #0000000F; */
  padding: 15px 0px;
  height: 124px;

  display: flex;
  flex-direction: column;
  /* align-items: center; */
  justify-content: center;
}

.value--unit {
  display: flex;
  flex-direction: row;
  /* justify-content: center; */
  justify-content: flex-start;
  align-items: flex-end;
}

.stats--title {
  font-size: 13px;
  font-weight: bold;
  color: #383838 !important;
}

.stats-info-icon {
  margin-left: 6px;
  color: #9f9f9f;
  cursor: pointer;
}

.stats--value {
  font-size: 25px;
  font-weight: bold;
  color: #383838;
}

.stats--unit {
  font-size: 14px;
  font-weight: 500;
  color: #d1d1d1;
  padding: 0 0 10px 10px;
}

.detail-tooltip-line {
  font-size: 12px;
  color: #9d9d9d;
}

.detail-tooltip-line strong {
  font-weight: 600;
  margin-right: 4px;
  color: #9d9d9d;
}

.stats-popover-text {
  color: #9d9d9d;
  display: inline-block;
}

.stats--icon {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.circle {
  /* Circle size */
  width: 57px;
  height: 57px;

  /* Make it a circle */
  border-radius: 50%;

  /* Circle color */
  /* Red color for demonstration */

  /* Centering the circle inside the container */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>